import React from 'react';
import { Create, fetchUtils, SimpleForm, TextInput, DateInput, AutocompleteArrayInput, Button, SelectArrayInput, SelectInput, ReferenceArrayInput } from 'react-admin';
import SaveIcon from '@material-ui/icons/Save';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import RunReportIcon from '@material-ui/icons/PlayCircleFilledRounded';
import DataTable from 'react-data-table-component';
import { Drawer } from '@material-ui/core';
import { UserReportsList, ReportName } from './components/user_reports_list.js';
import { UserReportsForm } from './components/user_reports_form.js';
import { MetricFilterComponent } from './components/metric_filter.js';
import CloudDownload from '@material-ui/icons/CloudDownload';
import authProvider from './authProvider';

const fetch = fetchUtils.fetchJson;

const BASE_URL = window.nobid_endpoint + '/ivt';
var globalRole = "publisher"

// https://github.com/jbetancur/react-data-table-component/blob/master/stories/DataTable/Basic/ExportCSV.stories.js
function convertArrayOfObjectsToCSV(array) {
  let result;
  const columnDelimiter = ',';
  const lineDelimiter = '\n';
  const keys = Object.keys(array[0]);
  result = '';
  result += keys.join(columnDelimiter);
  result += lineDelimiter;
  array.forEach(item => {
    let ctr = 0;
    keys.forEach(key => {
      if (ctr > 0) result += columnDelimiter;
      result += item[key];
      ctr++;
    });
    result += lineDelimiter;
  });
  return result;
}
function downloadCSV(array) {
  const link = document.createElement('a');
  let csv = convertArrayOfObjectsToCSV(array);
  if (csv == null) return;
  const filename = 'export.csv';
  if (!csv.match(/^data:text\/csv/i)) {
    csv = `data:text/csv;charset=utf-8,${csv}`;
  }
  link.setAttribute('href', encodeURI(csv));
  link.setAttribute('download', filename);
  link.click();
}
const choicesInterval = [
  { id: 'hour', name: 'Hourly' },
  { id: 'day', name: 'Daily' },
  { id: 'week', name: 'Weekly' },
  { id: 'month', name: 'Monthly' }
];
const dateRangeChoices = [
  { id: 0, name: 'Today' },
  { id: 1, name: 'Yesterday' },
  { id: 2, name: 'Last 2 Days' },
  { id: 3, name: 'Last 3 Days' },
  { id: 7, name: 'Last 7 Days' },
  { id: 8, name: 'Last 8 Days' },
  { id: 10, name: 'Last 10 Days' },
  { id: 30, name: 'Last 30 Days' },
  { id: 'custom', name: 'Custom' }
];
let choicesShow = [
  { id: 'publisher', name: 'Publisher' },
  { id: 'site', name: 'Site' },
  { id: 'source', name: 'Source' }
];
const choicesSource = [
  { id: 'appnexus-wo', name: 'WhiteOps 1' },
  { id: 'appnexus-wo-2', name: 'WhiteOps 2' }
]
const conditionalRowStyles = [
  {
    when: row => (row.ivt_rate > 20),
    style: { color: 'orange', backgroundColor: 'white' }
  },
  {
    when: row => (row.total > 100) && (row.ivt_rate > 20),
    style: { color: 'red', backgroundColor: 'white' }
  }
];
const BASE_COLUMNS = [
  {
    name: 'Date',
    selector: 'date',
    sortable: true,
    alwaysOn: true,
    Xcell: row => row.date,
    cell: row => ('' + row.date).substring(0, ('' + row.date).indexOf(':')).replace('T', ' ') + ':00'
  },
  {
    name: 'Publisher',
    selector: 'publisher_name',
    sortable: true,
    cell: row => <span>{row.publisher_name}</span>
  },
  {
    name: 'Publisher ID',
    selector: 'publisher_id',
    sortable: true,
    cell: row => <span>{row.publisher_id}</span>
  },
  {
    name: 'Network',
    selector: 'network_name',
    sortable: true,
    cell: row => <span>{row.network_name}</span>
  },
  {
    name: 'Network ID',
    selector: 'network_id',
    sortable: true,
    cell: row => <span>{row.network_id}</span>
  },
  {
    name: 'Site',
    selector: 'site_name',
    sortable: true,
    cell: row => <span>{row.site_name}</span>
  },
  {
    name: 'Site ID',
    selector: 'site_id',
    sortable: true,
    cell: row => <span>{row.site_id}</span>
  },
  {
    name: 'App ID',
    selector: 'app_id',
    sortable: true,
    cell: row => <span>{row.app_id}</span>
  },
  {
    name: 'Total',
    selector: 'total',
    alwaysOn: true,
    sortable: true,
    cell: row => <span>{new Intl.NumberFormat().format(Number.parseFloat(row.total).toFixed(2))}</span>
  },
  {
    name: 'IVT',
    selector: 'fraud',
    sortable: true,
    alwaysOn: true,
    cell: row => <span>{new Intl.NumberFormat().format(Number.parseFloat(row.fraud).toFixed(2))}</span>
  },
  {
    name: '%IVT Rate',
    selector: 'ivt_rate',
    sortable: true,
    alwaysOn: true,
    cell: row => <span>{new Intl.NumberFormat().format(Number.parseFloat(row.ivt_rate).toFixed(2))}</span>
  },
  {
    name: 'Source',
    selector: 'source',
    sortable: true,
    cell: row => <span>{row.source}</span>
  }
];
let columns = [];
BASE_COLUMNS.forEach(e => {
  if (e.alwaysOn) columns.push(e);
});
const metricChoices = [
  { id: 'ivt_rate', name: '%IVT Rate' },
  { id: 'total', name: 'Total' }
];
class IVTReportComponent extends React.Component {
  state = {
    data: [],
    start_date: '',
    end_date: '',
    metric_filter: [],
    loading: true,
    saving: false,
    total: 0,
    perPage: 25,
    params: { _end: 100000, _order: 'ASC', _start: 0 },
    interval: 'day',
    date_range: 8,
    show: [],
    app_id: '',
    code: 0,
    publisher_id: [],
    network_id: [],
    site_id: [],
    report_name: '',
    source: '',
    schedule: null,
    schedule_operator: null,
    schedule_value: null,
    schedule_emails: ''
  };
  constructor(permissions, props) {
    authProvider.getPermissions().then(({role}) => {
      globalRole = role;
      choicesShow = (role!=='admin')?choicesShow.filter(item => item.id!=='network' ):choicesShow;
    })
    super(props);
    this.state.loading = true
    // window.setInterval(()=>{console.log('===>METRIC FILTER STATE:', this.state);}, 10000);
  }
  setState(obj) {
    if (obj.metric_filter) {
      this.refs.metricFilter.setState({ data: [] });
      this.refs.metricFilter.setState({ data: obj.metric_filter });
      return;
    } else if (obj.show) this.resetColumns({ target: { value: obj.show } });
    super.setState(obj);
  }
  joinForUrl(params) {
    let ret = '';
    let prepend = '';
    for (let key in params) {
      if (['data', 'saved_data', 'params', 'saving', 'loading', 'listing', 'old_params', 'perPage'].includes(key)) continue;
      let val = params[key];
      if (typeof val != 'undefined' && val != null) {
        if (!Array.isArray(val)) ret += prepend + key + '=' + val;
        else {
          ret += prepend + key + '=' + val.join('&' + key + '=');
        }
        prepend = '&';
      }
    }
    return ret;
  }
  getQueryString() {
    let ret = this.joinForUrl(this.state.params);
    let buf = '';
    let metrics = this.refs.metricFilter.state.data;
    if (metrics) for (let i in metrics) {
      let r = metrics[i];
      if (r && r.metric && r.operator && r.value) {
        buf += '&metrics=' + r.metric + '|' + r.operator + '|' + r.value;
      }
    }
    if (buf != '') ret += buf;

    buf = this.joinForUrl(this.state);
    if (buf != '') ret += '&' + buf;
    return ret;
  }
  fetchData() {
    function updateState(obj, headers, json) {
      obj.setState({ data: json, saved_data: json, loading: false });
    }
    this.setState({ loading: true });
    let url = `${BASE_URL}?${this.getQueryString()}`
    let options = { headers: new Headers() };
    options.headers.set('accept', 'application/json');
    const token = localStorage.getItem('token');
    options.headers.set('Authorization', `Bearer ${token}`);
    fetch(url, options).then(({ headers, json }) => (
      updateState(this, headers, json)
    ));
  }
  handleClick = () => {
    this.fetchData();
  }
  resetColumns = (value) => {
    let v = [];
    let change = {};
    if (Array.isArray(value.target.value)) value.target.value.forEach(val => {
      if (val == 'publisher') {
        change['publisher_name'] = 'show';
        change['publisher_id'] = 'show';
      } else if (val == 'site') {
        change['site_name'] = 'show';
        change['site_id'] = 'show';
      } else if (val == 'network') {
        change['network_id'] = 'show';
        change['network_name'] = 'show';
      } else {
        change[val] = 'show';
      }
    })
    BASE_COLUMNS.forEach(e => {
      if (change[e.selector] == 'show' || e.alwaysOn) v.push(e);
    })
    columns = v;

    this.state[value.target.name] = value.target.value;
  }
  componentDidMount() {
    this.fetchData();
  }
  rowClicked(record) {
    window.location = `/#/sites/${record.site_id}`
  }
  exportData() {
    let records = this.state['data']
    downloadCSV(records)
  }
  filterData() {
    let val = document.getElementById('search_box').value;
    let records = []
    if (this.state['saved_data']) records = this.state['saved_data'];
    else {
      records = this.state['data']
      this.state['saved_data'] = records
    }
    let filtered = records.filter(item => {
      let ret = true;
      if (item.publisher_name) {
        ret = item.publisher_name.toLowerCase().includes(val.toLowerCase());
      }
      if (item.app_id) {
        ret = item.app_id.toLowerCase().includes(val.toLowerCase());
      }
      if (item.source) {
        ret = item.source.toLowerCase().includes(val.toLowerCase());
      }
      return ret;
    });
    this.setState({ data: filtered })
  }
  filterShow(value) {
    //console.log(value)
    if (value.includes('network') && !value.includes("publisher")) {
      value.push("publisher")
    }
    this.setState({ show: value })
  }
  render(props) {
    const { loading, data, total } = this.state;
    return (

      <div id="wrapper1">
        <Drawer anchor='right' ref='list_reports' open={this.state.listing}>
          <div style={{ width: '400px' }}>
            <UserReportsList parent={this} type='ivt' />
          </div>
        </Drawer>

        <Create basePath="/adcost" resource="" title="Advertising IVT Report" {...props}>
          <SimpleForm toolbar={false}>
            <ReportName parent={this} />

            <Drawer anchor='right' open={this.state.saving}>
              <div style={{ width: '400px' }}>
                <UserReportsForm parent={this} type='ivt' />
              </div>
            </Drawer>

            <div style={{ width: '100%', overflow: 'hidden' }} id="wrapper2">

              <div style={{ float: 'left', paddingRight: '5px' }}>
                <SelectInput label="Interval" source="interval"
                  choices={choicesInterval}
                  format={() => { return this.state.interval }}
                  defaultValue='day'
                  onChange={value => this.setState({ interval: value.target.value })}
                  disabled={loading} />
              </div>
              <div style={{ float: 'left', paddingRight: '5px' }}>
                <SelectInput label="Date Range" source="date_range"
                  format={() => { return this.state.date_range }}
                  choices={dateRangeChoices}
                  onChange={value => this.setState({ date_range: value.target.value })}
                  disabled={loading} />

                <div style={{ float: 'right', paddingLeft: '5px', display: ('custom' != this.state.date_range) ? 'none' : 'block' }}>
                  <div style={{ float: 'left', paddingRight: '5px', display: ('custom' != this.state.date_range) ? 'none' : 'block' }}>
                    <DateInput label="Start Date" source="start_date" allowEmpty
                      format={() => { return this.state.start_date }}
                      onChange={value => this.setState({ start_date: value.target.value })}
                      disabled={this.loading}
                      style={{ display: ('custom' != this.state.date_range) ? 'none' : 'block' }} />
                  </div>

                  <div style={{ float: 'left', display: ('custom' != this.state.date_range) ? 'none' : 'block' }}>
                    <DateInput label="End Date" source="end_date" allowEmpty
                      format={() => { return this.state.end_date }}
                      onChange={value => this.setState({ end_date: value.target.value })}
                      disabled={this.loading}
                      style={{ display: ('custom' != this.state.date_range) ? 'none' : 'block' }} />
                  </div>
                </div>

              </div>

              <div style={{ float: 'left', paddingRight: '5px' }}>
                <SelectArrayInput label="Show"
                  source="show"
                  format={() => { return this.state.show; }}
                  choices={choicesShow}
                  onChange={value => this.filterShow(value.target.value)}
                  defaultValue={[]}
                  style={{ width: '400px' }}
                  disabled={loading} />
              </div>

              <div style={{ float: 'right', paddingTop: '25px', paddingLeft: '10px' }}>
                <Button label='Run Report' onClick={this.handleClick} props={this} variant='contained'
                  color='primary' startIcon={<RunReportIcon />} disabled={loading} />
                <span style={{ paddingLeft: '5px' }} />

                <Button label="Save" props={this} variant="contained"
                  onClick={event => this.setState({ saving: true })}
                  color="primary" startIcon={<SaveIcon />} disabled={loading} />

                <span style={{ paddingLeft: '5px' }} />
                <Button label="Open" onClick={event => this.setState({ listing: true })} props={this} variant="contained"
                  color="primary" startIcon={<FolderOpenIcon />} disabled={loading} />
              </div>

            </div>

            <div style={{ height: '15px' }} />

            <div style={{ width: '100%', overflow: 'hidden' }} id="wrapper3">
              {/* {globalRole === 'admin' &&
                <div style={{ float: 'left', paddingRight: '5px' }}>
                  <ReferenceArrayInput
                    source="network_id"
                    format={() => { return this.state.network_id; }}
                    label="Network"
                    reference="networks"
                    basePath='networks'
                    perPage={15}
                    sort={{ field: 'name', order: 'ASC' }}
                    filterToQuery={searchText => ({ search_name: searchText })}
                    allowEmpty
                    onChange={value => this.state.network_id = value}
                  >
                    <AutocompleteArrayInput label="Networks"
                      optionText="name"
                      optionValue="code"
                      style={{ width: '100%' }}
                    />
                  </ReferenceArrayInput>
                </div>} */}

              <div style={{ float: 'left', paddingRight: '5px' }}>
                <ReferenceArrayInput
                  source="publisher_id"
                  format={() => { return this.state.publisher_id; }}
                  label="Publisher"
                  reference="publishers"
                  basePath='publishers'
                  perPage={15}
                  sort={{ field: 'name', order: 'ASC' }}
                  filterToQuery={searchText => ({ search_name: searchText })}
                  allowEmpty
                  onChange={value => this.state.publisher_id = value}
                >
                  <AutocompleteArrayInput label="Publishers"
                    optionText="name"
                    optionValue="code"
                    style={{ width: '100%' }}
                  />
                </ReferenceArrayInput>
              </div>

              <div style={{ float: 'left', paddingRight: '5px' }}>
                <ReferenceArrayInput
                  source="site_id"
                  format={() => { return this.state.site_id; }}
                  label="Site"
                  reference="sites"
                  basePath='sites'
                  perPage={15}
                  sort={{ field: 'name', order: 'ASC' }}
                  filterToQuery={searchText => ({ search_name: searchText })}
                  allowEmpty
                  onChange={value => this.state.site_id = value}>
                  <AutocompleteArrayInput label="Sites" optionText="adunit_path" optionValue="code" style={{ width: '100%' }} />
                </ReferenceArrayInput>
              </div>

              <div style={{ float: 'left', paddingRight: '5px' }}>
                <SelectInput label="Source" source="source"
                  choices={choicesSource}
                  format={() => { return this.state.source }}
                  allowEmpty
                  onChange={value => this.setState({ source: value.target.value })}
                  disabled={loading} />
              </div>

            </div>

            <div style={{ width: '100%' }}>
              <MetricFilterComponent ref='metricFilter' metricChoices={metricChoices} {...props} />
            </div>

          </SimpleForm></Create>

        <div style={{ height: '5px' }} />

        <div style={{ height: '5px' }} />
        <DataTable
          title="Advertising IVT Report"
          theme="dark"
          columns={columns}
          data={data}
          progressPending={loading}
          pagination
          fixedHeader
          paginationPerPage={30}
          paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
          dense
          conditionalRowStyles={conditionalRowStyles}
          highlightOnHover
          subHeader={!loading}
          subHeaderComponent={
            (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <input type="text" id='search_box' label="Search"
                  variant="outlined"
                  style={{ margin: '5px' }}
                  onChange={(target) => this.filterData()} />
                <CloudDownload
                  label="Export"
                  style={{ margin: '5px' }}
                  color="action"
                  onClick={() => this.exportData()}
                />
              </div>
            )
          }
        />

      </div>
    )
  }
};
export const IVTList = (props) => (
  <IVTReportComponent />
);